<template>
  <div id="news" class="animated fadeIn">
    <router-view/>
  </div>
</template>

<script>
export default {
}
</script>

<style lang="scss" scoped>
</style>
